<template>
    <div>
        <b-card no-body>
            <b-overlay class="p-1" :show="loading" opacity="0.2" rounded="sm">
                <div class="row">
                    <div class="col-md-6">
                        <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d',mode:'range', locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                    </div>
                    <div class="col-md-5">
                        <v-select-list :disabled="plates.length == 0" v-model="plate" :options="plates" label="PlateValue" placeholder="Plaka Seçiniz"></v-select-list>
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-primary" :disabled="!c_dates.StartDate || !c_dates.EndDate || !plate" v-on:click="getStatsPlate">Raporla</button>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card>
            <h4>Günlük Bazda Plakaya Göre İşlem Tutarı</h4>
            <narli-ferryboat-stats-by-plate-graph :statistics="statistics[0] || {}"></narli-ferryboat-stats-by-plate-graph>
        </b-card>
        <b-card>
            <h4>Günlük Bazda Plakaya Göre Toplam Geçiş Sayısı</h4>
            <narli-ferryboat-stats-by-plate-total-graph :statistics="statistics[0] || {}"></narli-ferryboat-stats-by-plate-total-graph>
        </b-card>
    </div>
</template>

<script>
import { BCard,BOverlay } from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import ReportsApi from "@/api/reports"
import VehicleOperationsApi from "@/api/vehicle-operations"
import NarliFerryboatStatsByPlateGraph from './components/NarliFerryboatStatsByPlateGraph'
import NarliFerryboatStatsByPlateTotalGraph from './components/NarliFerryboatStatsByPlateTotalGraph'


export default {
    components:{
        flatPickr,
        BCard,
        BOverlay,
        NarliFerryboatStatsByPlateGraph,
        NarliFerryboatStatsByPlateTotalGraph
    },
    data(){
        return{
            dateRange:null,
            plates:[],
            plate:null,
            loading:false,
            statistics:{
                StatsByDate:[]
            }
        }
    },
    mounted(){
        this.getPlates()
    },
    methods:{
        getPlates(){
            return new Promise((resolve,reject)=>{
                VehicleOperationsApi.Plate.ListViaNotUsingWithUsingPlate(null)
                .then(response => {
                    this.plates = response.data.Data
                    resolve()
                }).catch(err=>{ reject() })
            })
        },
        getStatsPlate(){
            if(this.c_dates.StartDate && this.c_dates.EndDate && this.plate?.PlateValue){
                this.loading = true
                let data = {StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate,Plate:this.plate?.PlateValue}
                ReportsApi.NarliFerryboat.ByPlate(data).then(res=>{
                    if(res.data.Success){
                        this.statistics = res.data.Data
                    }
                    this$result(res)
                    this.loading = false
                }).catch(err=>{
                    this.loading = false
                })
            }
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>